export default {
    get: function get(cname) {
        if (!document || !document.cookie) {
            return "";
        }

        var name = cname + "=";
        var ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];

            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }

            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }

        return "";
    },
    set: function set(cname, cvalue, exHours) {
        if (!document) {
            return;
        }

        var d = new Date();

        d.setTime(d.getTime() + exHours * 60 * 60 * 1000);
        document.cookie = cname + "=" + cvalue + "; expires=" + d.toUTCString();
    }
};


//////////////////
// WEBPACK FOOTER
// ./submodules/dialogloop-sdk-js/dist/Utils/Cookie.js
// module id = 501
// module chunks = 0